PluginBadgesView = require 'app/scripts/views/plugin/plugin-badges-view'
PluginCardDetailBadgeView = require 'app/scripts/views/plugin/plugin-card-detail-badge-view'
{ sendPluginScreenEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
{ trackUe } = require '@trello/analytics'

module.exports = class PluginCardDetailBadgesView extends PluginBadgesView
  tagName: 'div'
  badgeView: PluginCardDetailBadgeView

  isDetailView: -> true

  runnerOptions: ->
    command: 'card-detail-badges'
    board: @model.getBoard()
    card: @model

  trackBadges: (idPlugin) ->
    if !@trackedDetailsBadges?
      @trackedDetailsBadges = {}
    if !@trackedDetailsBadges[idPlugin]
      @trackedDetailsBadges[idPlugin] = true
      trackUe('card details', 'views', 'Power-Up', '', '', 'card-detail-badges', idPlugin)
      sendPluginScreenEvent(idPlugin, 'pupCardDetailBadges')
